import React, { useEffect, useState, useRef } from "react";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SwiperSlide } from "swiper/react";
import { isMobile } from "react-device-detect";
import { useArticlesInfinite } from "../../../services/apiHooks/articles";
import Section from "./Section";
import { useLinks } from "../../../services/helpers/links";
import { Loader } from "../../common";
import { ArticleCardWrapper } from "../../common/Article/ArticleCardWrapper";
import { CarouselWrapper } from "./CarouselWrapper";

const MarkoSection = ({
  background = "dark", // "light" | "dark"
}) => {
  const { articlesData, isLoading } = useArticlesInfinite({
    limit: 4,
    categoriesList: 90,
  });
  const { t } = useTranslation(["articlesMeta"]);
  const { makro: makroLink } = useLinks();

  const [articles, setArticles] = useState([]);
  const swiper = useRef(null);

  useEffect(() => {
    if (
      !isLoading &&
      articlesData &&
      articlesData[0].results &&
      articlesData[0].results.length &&
      articles.length === 0
    ) {
      setArticles(articlesData[0].results);
    }
  }, [articlesData, isLoading]);

  return (
    <div className={`Sections--${background}`}>
      <Container>
        <Section title={<h2>{t("articlesMeta:categories.90")}</h2>}>
          <span>
            <div className="Sections__categories">
              <Link to={makroLink} className="Sections__more">
                {t("widgets:news.allArticles")}
              </Link>
            </div>
            {isLoading ? (
              <Loader small />
            ) : (
              <CarouselWrapper
                showNav={isMobile}
                showPag={isMobile}
                slidesPerViewSmall={1}
                slidesPerViewMed={4}
                slidesPerViewBig={4}
                swiperRef={swiper}
              >
                {articles.map(el => (
                  <SwiperSlide
                    key={`Slide-${el.slug}`}
                    style={{ height: "auto" }}
                  >
                    <ArticleCardWrapper article={el} key={el.id} id={el.id} />
                  </SwiperSlide>
                ))}
              </CarouselWrapper>
            )}
          </span>
        </Section>
      </Container>
    </div>
  );
};

export default MarkoSection;
